import { observer } from 'mobx-react-lite';

import { AppLogo } from '@/assets/icons/AppLogo';
import { XStack, YStack } from '@/components/ui';
import { classList } from '@/utils/cn';

import { AgentAvatar } from './agents-avatar';
import { agentsStore } from './agents.store';
import './agents.css';

type AgentWorkingIndicatorProps = {
  id: string;
  threadId?: string;
  verb?: string;
  usingTool?: boolean;
};

export const AgentWorkingIndicator = observer(
  ({
    id,
    threadId,
    verb = 'thinking',
    usingTool = false,
  }: AgentWorkingIndicatorProps) => {
    const agent = threadId ? agentsStore.getByChatId(threadId) : undefined;
    const label =
      agent && verb === 'working'
        ? `${agent.name} is working`
        : verb.charAt(0).toUpperCase() + verb.slice(1);

    return (
      <YStack
        data-message-id={id}
        className={classList('relative gap-4 w-full px-1 py-3')}
      >
        <XStack className="items-center gap-2 w-full">
          <span className="flex shrink-0">
            {agent ? (
              <AgentAvatar
                bird={agent.bird}
                activity={usingTool ? 'working' : 'thinking'}
                className="size-5"
              />
            ) : (
              <AppLogo size={16} />
            )}
          </span>
          <span className="text-sm font-medium select-none">
            {[...label].map((letter, index) => (
              <span
                key={index}
                className="inline-block agents-letter-wave"
                style={{ animationDelay: `${index * 0.04}s` }}
              >
                {letter === ' ' ? '\u00A0' : letter}
              </span>
            ))}
          </span>
        </XStack>
      </YStack>
    );
  }
);
